import React, {useEffect, useState} from "react";
import {
  Box,
  Paper,
  Typography,
  InputLabel,
  FormHelperText,
  Grid,
  Alert,
  Snackbar,
  CircularProgress,
  Select,
  MenuItem,
  FormControl
} from "@mui/material";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import dayjs from "dayjs";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import properties from "constants/ApplicationConstants";
import {POST, GET} from "APIclient";
import {useNavigate, useSearchParams} from "react-router-dom";

const ExtendKraForEmployee = () => {
  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const empId = searchParams.get("empId");
  const empName = searchParams.get("name");

  const [selectedEmpId, setSelectedEmpId] = useState("");
  const [kraEndDate, setKraEndDate] = useState(null);
  const [errors, setErrors] = useState({});
  const [employeeList, setEmployeeList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isLoadingData, setIsLoadingData] = useState(false);

  const [snackOpen, setSnackOpen] = useState(false);
  const [snackColor, setSnackColor] = useState("success");
  const [snackMessage, setSnackMessage] = useState("");

  const showSnack = (message, color = "success") => {
    setSnackMessage(message);
    setSnackColor(color);
    setSnackOpen(true);
  };

  const handleCloseSnack = () => setSnackOpen(false);

  // useEffect(() => {
  //   const fetchEmployees = async () => {
  //     setIsLoadingData(true);
  //     try {
  //       const url = "admin/employeeDetails";
  //       const response = await GET(url);
  //       if (response?.status === 200) {
  //         setEmployeeList(response.data.data || []);
  //       } else {
  //         showSnack("Failed to load employees", "error");
  //       }
  //     } catch (error) {
  //       showSnack(error?.response?.data?.message || "Failed to load employees", "error");
  //     } finally {
  //       setIsLoadingData(false);
  //     }
  //   };

  //   fetchEmployees();
  // }, []);

  const validate = () => {
    const newErrors = {};
    // if (!selectedEmpId) newErrors.emp_id = "Please select an employee";
    if (!kraEndDate) newErrors.kra_end_date = "Please select KRA end date";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);
    const payload = {
      empId: empId,
      employeeKraEndDate: kraEndDate.format("YYYY-MM-DD")
    };

    try {
      const url = "admin/appraisal-cycle/extend-kra";
      const response = await POST(url, payload);
      if (response?.status === 200) {
        showSnack(
          response.data.message || "KRA extended successfully for the employee!",
          "success"
        );
        setSelectedEmpId("");
        setKraEndDate(null);
      }
    } catch (error) {
      showSnack(
        error?.response?.data?.message || "Failed to extend KRA. Please try again.",
        "error"
      );
    } finally {
      setLoading(false);
    }
  };

  if (isLoadingData) {
    return (
      <DashboardLayout>
        <DashboardNavbar />
        <MDBox display="flex" justifyContent="center" alignItems="center" minHeight="70vh">
          <CircularProgress color="info" size={50} />
        </MDBox>
      </DashboardLayout>
    );
  }

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={1}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <Box sx={{flexGrow: 1, p: 2}}>
            <Paper elevation={3}>
              <Box sx={{background: properties.colors.bgcolorbluethem, color: "white", p: 2}}>
                <Typography
                  variant="h6"
                  fontSize={15}
                  sx={{color: properties.colors.White, fontFamily: properties.fontFamily}}
                >
                  Extend KRA Deadline - {empName} [{empId}]
                </Typography>
              </Box>

              <Box component="form" onSubmit={handleSubmit} sx={{p: 3}}>
                <Grid container spacing={3} alignItems="center" sx={{mb: 3}}>
                  {/* <Grid item xs={12} md={3}>
                    <InputLabel sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}>
                      Select Employee <span style={{color: "red"}}>*</span>
                    </InputLabel>
                  </Grid> */}
                  {/* <Grid item xs={12} md={6}>
                    <FormControl sx={{width: 322}} error={!!errors.emp_id}>
                      <Select
                        value={selectedEmpId}
                        onChange={e => {
                          setSelectedEmpId(e.target.value);
                          setErrors(prev => ({...prev, emp_id: null}));
                        }}
                        displayEmpty
                        sx={{height: 44}}
                      >
                        <MenuItem value="" disabled>
                          Select Employee
                        </MenuItem>
                        {employeeList.length > 0 ? (
                          employeeList.map(emp => (
                            <MenuItem key={emp.empId} value={emp.empId}>
                              {emp.firstName} {emp.lastName} [{emp.empId}]
                            </MenuItem>
                          ))
                        ) : (
                          <MenuItem disabled>No employees found</MenuItem>
                        )}
                      </Select>
                      {errors.emp_id && <FormHelperText>{errors.emp_id}</FormHelperText>}
                    </FormControl>
                  </Grid> */}
                </Grid>

                <Grid container spacing={3} alignItems="center" sx={{mb: 3, mt: 3}}>
                  <Grid item xs={12} md={3}>
                    <InputLabel sx={{fontWeight: "bold", fontFamily: properties.fontFamily}}>
                      Employee KRA End Date <span style={{color: "red"}}>*</span>
                    </InputLabel>
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <DatePicker
                      value={kraEndDate}
                      onChange={date => {
                        setKraEndDate(date);
                        setErrors(prev => ({...prev, kra_end_date: null}));
                      }}
                      format="DD-MM-YYYY"
                      minDate={dayjs()}
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          error: !!errors.kra_end_date,
                          helperText: errors.kra_end_date || "Select new deadline"
                        }
                      }}
                    />
                  </Grid>
                </Grid>

                <Box sx={{mt: 4, textAlign: "right", bgcolor: "grey.100", p: 2, borderRadius: 1}}>
                  <MDButton
                    variant="gradient"
                    color="warning"
                    sx={{width: "15 g", mr: 2, fontFamily: properties.fontFamily}}
                    onClick={() => navigate(-1)}
                  >
                    Back
                  </MDButton>
                  <MDButton
                    variant="gradient"
                    color="info"
                    type="submit"
                    disabled={loading || !empId || !kraEndDate}
                    sx={{
                      width: "15ch",
                      background: properties.colors.bgcolorbluethem,
                      fontFamily: properties.fontFamily,
                      "&:hover": {background: properties.colors.bgcolorbluethem}
                    }}
                  >
                    {loading ? "Saving..." : "Save"}
                  </MDButton>
                </Box>
              </Box>
            </Paper>
          </Box>
        </LocalizationProvider>
      </MDBox>

      <Snackbar
        open={snackOpen}
        autoHideDuration={6000}
        onClose={handleCloseSnack}
        anchorOrigin={{vertical: "top", horizontal: "right"}}
      >
        <Alert
          onClose={handleCloseSnack}
          severity={snackColor}
          variant="filled"
          sx={{width: "100%", color: " #fff"}}
        >
          {snackMessage}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
};

export default ExtendKraForEmployee;
